// Observe available layout; a keyboard resize alone is not physical rotation.
export function observeRacquetOrientation(onChange) {
  const query = window.matchMedia('(orientation: landscape)')
  const orientation = window.screen?.orientation
  const physical = () => orientation?.type || window.orientation
  let previous = physical()
  const changed = () => {
    const next = physical(), rotated = next !== previous
    previous = next
    if (!rotated && document.activeElement?.matches('input,select,textarea,[contenteditable="true"]')) return
    onChange(query.matches)
  }
  let frame
  const rotated = () => {
    previous = physical()
    cancelAnimationFrame(frame)
    frame = requestAnimationFrame(() => onChange(query.matches))
  }
  orientation?.addEventListener?.('change', rotated)
  window.addEventListener('orientationchange', rotated)
  query.addEventListener('change', changed)
  onChange(query.matches)
  return () => {
    cancelAnimationFrame(frame)
    orientation?.removeEventListener?.('change', rotated)
    window.removeEventListener('orientationchange', rotated)
    query.removeEventListener('change', changed)
  }
}
